import { NgModule } from '@angular/core';
import { InformationBoxComponent } from './information-box.component';
import { CommonModule } from '@angular/common';
import { InformationBoxService } from './information-box.service';
import { TranslateModule } from '@ngx-translate/core';
import { PipesModule } from '../../../shared/_pipes/pipes.module';
import { DirectivesModule } from '../../directives/directives.module';

@NgModule({
    imports: [
        CommonModule,
        TranslateModule,
        PipesModule,
        DirectivesModule
    ],
    declarations: [InformationBoxComponent],
    exports: [InformationBoxComponent],
    providers: [InformationBoxService]
})
export class InformationBoxModule { }
